<template>
  <PmNotificationResourceRequestFeedbackPure
    v-bind="{ ...$attrs, ...props }"
    @open-details="openDetails"
    @jump="jumpToJobOrProjectinCalendar"
  />
</template>

<script setup lang="ts">
import { DATA_MODAL_TYPE } from '@/constants/persoplan'
import { EVENT } from '@/constants/events'
import EventHub from '@/eventHub'
import PmNotificationResourceRequestFeedbackPure, {
  type Props as PropsNotificationResourceRequestFeedbackPure,
} from '@/components/PmNotification/PmNotificationResourceRequestFeedback/PmNotificationResourceRequestFeedbackPure.vue'
import { useCalendarJump } from '@/composition/useCalendarJump'
import type { CalendarItemType } from '@/constants/persoplan'

export interface Props extends PropsNotificationResourceRequestFeedbackPure {
  resourceAllocationIds: number[]
  calendarItem?: {
    id: number
    type: Extract<CalendarItemType, 'job' | 'project'>
    startDate: Date
    endDate: Date
  }
}

const props = withDefaults(defineProps<Props>(), {})

const calendarJump = useCalendarJump()

function openDetails() {
  const resourceAllocationId = props.resourceAllocationIds[0]
  if (!resourceAllocationId)
    throw new Error('resourceAllocationId is undefined')

  EventHub.$emit(EVENT.DATA_MODAL_SHOW, {
    type: DATA_MODAL_TYPE.RESOURCE_REQUEST,
    id: resourceAllocationId,
  })
}

function jumpToJobOrProjectinCalendar() {
  if (!props.calendarItem) {
    throw new Error('calendarItem is undefined, jump is not possilbe')
  }

  calendarJump.jumpTo({
    type: props.calendarItem.type,
    id: props.calendarItem.id,
    startDate: props.calendarItem.startDate,
    endDate: props.calendarItem.endDate,
  })
}
</script>
